import React from 'react'
import { css } from '@emotion/core'
import { colors, LayoutBand, MarginBox, useContainerWidth } from '@fs/zion-ui'
import { Person } from '@fs/zion-person'
import { useChangelogParams } from '../../../changelogRouteUtil'
import ParentChildHeaderSkeleton from './ParentChildHeaderSkeleton'
import OtherRelationshipHeaderSkeleton from './OtherRelationshipHeaderSkeleton'
import CoupleHeaderSkeleton from './CoupleHeaderSkeleton'

const dividerCss = css`
  height: 6px;

  & > div > div {
    border-bottom: 0px;
  }
  background-color: ${colors.gray80};
`

export default function PersonStickyHeaderSkeleton(): JSX.Element {
  const { relationshipType, relationshipId } = useChangelogParams()
  const atWidth = useContainerWidth()
  return (
    <>
      <LayoutBand maxWidth="xxl">
        <MarginBox marginY="xxs">
          {relationshipType === 'parent-child' && relationshipId && (
            <ParentChildHeaderSkeleton isSmallScreen={atWidth({ default: true, lg: false })} />
          )}
          {relationshipType === 'couple' && relationshipId && <CoupleHeaderSkeleton />}
          {relationshipType === 'association' && relationshipId && <OtherRelationshipHeaderSkeleton />}
          {!relationshipType && (
            <Person
              noBoldName
              personObj={{}}
              openPersonOverlay
              componentSize={atWidth({ default: 'sm', lg: 'lg' })}
              avatarSize="smaller"
              loading
            />
          )}
        </MarginBox>
      </LayoutBand>
      <div css={dividerCss} />
    </>
  )
}
